import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

const blocks: Record<string, ComponentType<any>> = {
  PostText: dynamic(() => import('./PostText')),
  PostIframe: dynamic(() => import('./PostIframe')),
  PostYoutube: dynamic(() => import('./PostYoutube')),
  PostQuote: dynamic(() => import('./PostQuote')),
  PostMedia: dynamic(() => import('./PostMedia')),
  PostCta: dynamic(() => import('./PostCta')),
}

export default blocks
